import React from 'react';
import { Zap, XCircle, CheckCircle } from 'lucide-react';
export function OriginStory() {
  return <section className="bg-forest-50 py-20 px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-bold text-forest-900" data-id="element-126">
            El Mecanismo que Cambia Todo:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-127">
          {/* Conventional Method */}
          <div className="bg-white p-8 rounded-3xl shadow-md border border-forest-800/10" data-id="element-128">
            <div className="flex items-center space-x-3 mb-6" data-id="element-129">
              <XCircle className="w-8 h-8 text-pain" data-id="element-130" />
              <h3 className="text-2xl font-bold text-forest-900" data-id="element-131">
                MÉTODO CONVENCIONAL
              </h3>
            </div>
            <ul className="space-y-4 text-lg text-forest-800 font-medium" data-id="element-132">
              <li className="flex items-center space-x-3" data-id="element-133">
                <span className="text-pain" data-id="element-134">→</span>
                <span data-id="element-135">Eliminar alimentos</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-136">
                <span className="text-pain" data-id="element-137">→</span>
                <span data-id="element-138">Restricción</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-139">
                <span className="text-pain" data-id="element-140">→</span>
                <span data-id="element-141">Antojo</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-142">
                <span className="text-pain" data-id="element-143">→</span>
                <span data-id="element-144">Abandono</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-145">
                <span className="text-pain" data-id="element-146">→</span>
                <span className="font-bold text-pain" data-id="element-147">SIBO vuelve</span>
              </li>
            </ul>
          </div>

          {/* SIBO Protocol */}
          <div className="bg-forest-900 p-8 rounded-3xl shadow-xl border-2 border-gold-400 text-white" data-id="element-148">
            <div className="flex items-center space-x-3 mb-6" data-id="element-149">
              <CheckCircle className="w-8 h-8 text-solution" data-id="element-150" />
              <h3 className="text-2xl font-bold text-gold-400" data-id="element-151">
                PROTOCOLO RESCATE SIBO™
              </h3>
            </div>
            <ul className="space-y-4 text-lg font-medium" data-id="element-152">
              <li className="flex items-center space-x-3" data-id="element-153">
                <span className="text-solution" data-id="element-154">→</span>
                <span data-id="element-155">Entender el mecanismo</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-156">
                <span className="text-solution" data-id="element-157">→</span>
                <span data-id="element-158">Eliminar el combustible del SIBO</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-159">
                <span className="text-solution" data-id="element-160">→</span>
                <span data-id="element-161">Restaurar el MMC</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-162">
                <span className="text-solution" data-id="element-163">→</span>
                <span data-id="element-164">Reparar la mucosa</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-165">
                <span className="text-solution" data-id="element-166">→</span>
                <span className="font-bold text-solution" data-id="element-167">
                  Libertad digestiva
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-168">
          <p className="text-xl md:text-2xl text-forest-800 italic font-medium" data-id="element-169">
            "En lugar de pelear contra tu intestino... le damos exactamente lo
            que necesita para sanar."
          </p>
        </div>
      </div>
    </section>;
}